/**
 * Shared helpers and components for ScenarioLab
 * 
 * Style helpers, form components, and small UI pieces.
 */

import React from 'react';
import { Badge } from '../../ui/badge';

// Style helpers for recommendation-based styling
export const getRecommendationCardStyle = (recommendation) => {
  const styles = {
    reroute: 'bg-amber-500/10 border-amber-500/50',
    proceed: 'bg-emerald-500/10 border-emerald-500/50'
  };
  return styles[recommendation] || 'bg-red-500/10 border-red-500/50';
};

export const getRecommendationBgStyle = (recommendation) => {
  const styles = {
    reroute: 'bg-amber-500/20',
    proceed: 'bg-emerald-500/20'
  };
  return styles[recommendation] || 'bg-red-500/20';
};

export const getRecommendationTextStyle = (recommendation) => {
  const styles = {
    reroute: 'text-amber-400',
    proceed: 'text-emerald-400'
  };
  return styles[recommendation] || 'text-red-400';
};

export const getConfidenceStyle = (level) => {
  const styles = {
    high: 'bg-emerald-500',
    medium: 'bg-amber-500'
  };
  return styles[level] || 'bg-red-500';
};

export const getRiskStyle = (risk) => {
  const styles = {
    HIGH: 'bg-red-500',
    LOW: 'bg-emerald-500',
    MEDIUM: 'bg-amber-500'
  };
  return styles[risk] || 'bg-amber-500';
};

// Toggle Switch component
export const Toggle = ({ checked, onChange, label }) => (
  <label className="flex items-center gap-2 cursor-pointer">
    <div className={`relative w-10 h-5 rounded-full transition-colors ${checked ? 'bg-cyan-600' : 'bg-slate-700'}`}>
      <div className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white transition-transform ${checked ? 'translate-x-5' : ''}`} />
    </div>
    <span className="text-sm text-slate-300">{label}</span>
  </label>
);

// Select component
export const Select = ({ value, onChange, options, label }) => (
  <div className="space-y-1">
    <label className="text-xs text-slate-400">{label}</label>
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className="w-full bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-cyan-500"
    >
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  </div>
);

// Multi-select for disruption types
export const MultiSelect = ({ values, onChange, options, label }) => (
  <div className="space-y-1">
    <label className="text-xs text-slate-400">{label}</label>
    <div className="flex flex-wrap gap-2">
      {options.map(opt => {
        const isSelected = values.includes(opt.value);
        return (
          <button
            key={opt.value}
            onClick={() => {
              if (isSelected) {
                onChange(values.filter(v => v !== opt.value));
              } else {
                onChange([...values, opt.value]);
              }
            }}
            className={`px-3 py-1 rounded-full text-xs transition-colors ${
              isSelected 
                ? 'bg-cyan-600 text-white' 
                : 'bg-slate-800 text-slate-400 hover:bg-slate-700'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  </div>
);
